import { useCallback, useEffect } from 'react';
import { Metrics } from 'customer-data-objects/metrics/Metrics';
export const useAutosaveWindowEvents = getPackets => {
  const handleBeforeUnload = useCallback(e => {
    if (getPackets().length > 0) {
      Metrics.counter('autosave-saving-and-beforeunload').increment();
      e.preventDefault();
      e.returnValue = true;
    }
  }, [getPackets]);
  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [handleBeforeUnload]);
};